import { Link, useSearchParams } from 'react-router-dom';
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import '../PagamentoConcluido/index.scss';

export default function PagamentoPendente() {
    const [searchParams] = useSearchParams();
    const orderNsu = searchParams.get('order_nsu') || '';

    return (
        <section className='container-pagamento-resultado pendente'>
            <Cabecalho />
            <main>
                <div className='palco-status'>
                    <div className='fundo-status-svg' aria-hidden='true'>
                        <svg className='orb orb-1' viewBox='0 0 120 120'><circle cx='60' cy='60' r='60' /></svg>
                        <svg className='orb orb-2' viewBox='0 0 80 80'><circle cx='40' cy='40' r='40' /></svg>
                        <svg className='orb orb-3' viewBox='0 0 150 150'><circle cx='75' cy='75' r='75' /></svg>
                        <svg className='orb orb-4' viewBox='0 0 95 95'><circle cx='47.5' cy='47.5' r='47.5' /></svg>
                        <svg className='orb orb-5' viewBox='0 0 180 180'><circle cx='90' cy='90' r='90' /></svg>
                        <svg className='orb orb-6' viewBox='0 0 62 62'><circle cx='31' cy='31' r='31' /></svg>
                    </div>

                    <div className='icon'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0012 3.125C9.66289 3.125 9.35352 3.4125 9.37617 3.75L9.68867 12.1875C9.68867 12.2704 9.7216 12.3499 9.7802 12.4085C9.83881 12.4671 9.91829 12.5 10.0012 12.5C10.0841 12.5 10.1635 12.4671 10.2221 12.4085C10.2807 12.3499 10.3137 12.2704 10.3137 12.1875L10.6262 3.75C10.6488 3.4125 10.3395 3.125 10.0012 3.125Z" stroke="#FFFF00" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10 16.875C10.3452 16.875 10.625 16.5952 10.625 16.25C10.625 15.9048 10.3452 15.625 10 15.625C9.65482 15.625 9.375 15.9048 9.375 16.25C9.375 16.5952 9.65482 16.875 10 16.875Z" stroke="#FFFF00" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
</div>
                    <h1>Pagamento pendente</h1>
                    <p>Recebemos seu retorno, mas o pagamento ainda nao foi confirmado.</p>
                    <div className='detalhes'>
                        <p className='numero-metodo'>
                            <span className='label'>Pedido:</span>
                            <strong>{orderNsu || 'Nao informado'}</strong>
                        </p>
                        <p>Assim que aprovado, ele aparece como pago em seus pedidos.</p>
                    </div>
                    <div className='acoes'>
                        <Link to='/menu/perfil/meuspedidos' className='btn primario'>Acompanhar pedido</Link>
                        <Link to='/' className='btn secundario'>Voltar para a loja</Link>
                    </div>
                </div>
            </main>
            <Rodape />
        </section>
    );
}
